import { fetchProducts } from 'api/varify';
import { useEffect, useMemo, useState } from 'react';
import { ProductOfferType, USProductOffer } from 'types';
import { EnvironmentTypes } from '@raisin/cp-utils';

const isStaging = () => process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === EnvironmentTypes.STAGING;

export const useUSProductOffers = ({
  productOffers: fetchedProductOffers,
  bankId,
  productId,
  featured = [],
  inactive = [],
}: {
  productOffers: Array<USProductOffer>;
  bankId?: string;
  productId?: string;
  featured?: string[];
  inactive?: string[];
}) => {
  const [productOffers, setProductOffers] = useState<USProductOffer[]>(fetchedProductOffers ?? []);

  /**
   * Staging load balancer allows only whitelisted IPs and netlify is not whitelisted
   * On all other environments products are fetched server side
   */
  useEffect(() => {
    if (!fetchedProductOffers.length && isStaging()) {
      (async () => {
        const fetched = await fetchProducts();
        setProductOffers(fetched);
      })();
    }
  }, [fetchedProductOffers]);

  const filteredData: Record<ProductOfferType | 'FEATURED', USProductOffer[]> = useMemo(
    () =>
      productOffers.reduce(
        (acc, item) => {
          if (productId?.trim() && item.id !== productId) {
            return acc;
          }

          if (bankId?.trim() && item.productBank.id !== bankId) {
            return acc;
          }

          if (inactive.includes(item.id)) {
            return acc;
          }

          if (featured.includes(item.id)) {
            acc.FEATURED.push(item);
          }

          acc[item.type].push(item);
          return acc;
        },
        {
          FEATURED: [] as USProductOffer[],
          SAVINGS_ACCOUNT: [] as USProductOffer[],
          HIGH_YIELD_CD: [] as USProductOffer[],
          NO_PENALTY_CD: [] as USProductOffer[],
        },
      ),
    [productOffers, bankId, inactive, featured, productId],
  );

  return {
    ...filteredData,
  };
};
